import React from 'react'
import { ModalSeeker } from '@ui-seeker/core'
import { reportSearchesModalId } from '@signals'
import AppReportSearchesModalContent from './Content'
import { REPORT_STATUS } from '@constants'


export default function AppReportSearchesModal({ data, isExtras = false }) {
	if (reportSearchesModalId.value === null || data.length <= 0) return null

	const {
		name,
		statusLastExecution,
		status_last_execution,
		status,
	} = data?.filter(a => a?.idLastExecution === reportSearchesModalId.value || a?.id_last_execution === reportSearchesModalId.value || a?.id_batch === reportSearchesModalId.value)[0]
	const isRunning = statusLastExecution === REPORT_STATUS.RUNNING || status_last_execution === REPORT_STATUS.RUNNING || status === REPORT_STATUS.RUNNING

	return <ModalSeeker
		hideActions
		title={`${name}: Search Summary`}
		isOpen={reportSearchesModalId.value !== null}
		controller={() => reportSearchesModalId.value = null}
		containerProps={{ maxWidth: 'lg', p: 2 }}
	>
		<AppReportSearchesModalContent
			id_report={reportSearchesModalId.value}
			isRunning={isRunning}
			isExtras={isExtras}
		/>
	</ModalSeeker>
}